export const CREATE_NEW_ACCOUNT_PROFILE = "Create New Account Profile";
export const NO_ACCOUNT_PROFILES_DATA = "Sorry, we couldn't find any account profiles.";

export const showOptions = [
  { id: 0, value: undefined, text: 'All' },
  { id: 1, value: false, text: 'Only Account Profiles' },
  { id: 2, value: true, text: 'Only Templates' },
];
